import { useContext } from "react";
import { CurrentPathContext } from "../contexts/CurrentPathContext";

export function useCurrentPath(): string {
  const value = useContext(CurrentPathContext);
  if (value === null) {
    throw new Error("useCurrentPath must be used within a CurrentPathProvider");
  }
  return value;
}
